export enum SearchItemType {
  Company = 'company',
  PCML = 'private-company-monitor-list',
  Research = 'research',
  News = 'news',
  LatestVideos = 'latestVideos',
}
